{
    "name": "duckdb-wasm-es-shell",
    "version": "1.29.6",
    "description": "",
    "author": "Andre Kohn <kohn.a@outlook.com>",
    "license": "MIT",
    "repository": {
        "type": "git",
        "url": "https://github.com/duckdb/duckdb-wasm.git"
    },
    "keywords": [
        "sql",
        "duckdb",
        "relational",
        "database",
        "data",
        "query",
        "wasm",
        "analytics",
        "olap",
        "arrow",
        "parquet",
        "json",
        "csv"
    ],
    "dependencies": {
        "duckdb-wasm-es": "^1.29.6",
        "xterm": "^5.1.0",
        "xterm-addon-fit": "^0.7.0",
        "xterm-addon-web-links": "^0.8.0",
        "xterm-addon-webgl": "^0.15.0"
    },
    "devDependencies": {
        "esbuild": "^0.18.13",
        "eslint": "^8.47.0",
        "eslint-plugin-jasmine": "^4.1.3",
        "eslint-plugin-react": "^7.33.2",
        "jasmine": "^5.1.0",
        "jasmine-core": "^5.0.0",
        "jasmine-spec-reporter": "^7.0.0",
        "make-dir": "^4.0.0",
        "prettier": "^2.8.4",
        "rimraf": "^4.3.0",
        "wasm-pack": "^0.12.1"
    },
    "scripts": {
        "install:wasmpack": "node ../../node_modules/wasm-pack/install.js",
        "build:debug": "node bundle.mjs debug && tsc --emitDeclarationOnly",
        "build:release": "node bundle.mjs release && tsc --emitDeclarationOnly",
        "lint": "eslint src"
    },
    "files": [
        "dist",
        "!dist/types/test"
    ],
    "main": "dist/shell.cjs",
    "module": "dist/shell.mjs",
    "types": "dist/shell.d.ts",
    "jsdelivr": "dist/shell.cjs",
    "unpkg": "dist/shell.mjs",
    "sideEffects": false,
    "exports": {
        "./dist/shell_bg.wasm": "./dist/shell_bg.wasm",
        "./dist/shell.js": "./dist/shell.js",
        "./dist/shell.cjs": "./dist/shell.cjs",
        "./dist/shell.mjs": "./dist/shell.mjs",
        "./dist/shell": "./dist/shell.mjs",
        ".": {
            "types": "./dist/shell.d.ts",
            "import": "./dist/shell.mjs",
            "require": "./dist/shell.cjs"
        }
    }
}
